module.exports = __webpack_public_path__ + "static/img/case3.be227a51.png";